import axios from 'axios';
import { store } from '../store';

export function loadSOAs(params = { }) {
  const state = store.getState();
  const { token } = state.auth;
  const {
    sortTerm,
    sortInverse,
    // submitDateStart,
    // submitDateEnd,
    submitted,
    // searchTerm,
    page,
    pageSize,
  } = state.soas;

  const {
    agentUsername = '',
    shopperUsername = '',
  } = params;


  return axios({
    url: `${process.env.REACT_APP_MMB_API_URL}/api/supervisor/soa/`,
    method: 'get',
    headers: { Authorization: `Token ${token}` },
    params: {
      agent_username: agentUsername,
      shopper_username: shopperUsername,
      // submit_date_start: submitDateStart,
      // submit_date_end: submitDateEnd,
      // Our querystring can't handle submitted=(true-or-false) - so only add it if set
      ...(submitted === 'false' || submitted === 'true'
        ? { submitted }
        : { }),
      ordering: `${sortInverse ? '-' : ''}${sortTerm}`,
      page,
      page_size: pageSize,
    },
  })
    .then(({ data = {} }) => data)
    .catch(err => err);
}

// todo - This is for the secondary SOA view from the leads table. Probably remove for now and just use above.
export const loadShopperSOAs = (username) => new Promise((resolve, reject) => {
  axios({
    method: 'GET',
    url: `/agent/soa/?shopper=${username}`,
  })
    .then((data) => {
      data.sort((a, b) => {
        const dateA = a.submit_date || a.created;
        const dateB = b.submit_date || b.created;
        if (dateA < dateB) return 1;
        if (dateA > dateB) return -1;
        return 0;
      });
      resolve(data);
    })
    .catch((err) => {
      reject(err);
    });
});

export const download = () => {
};
